import RequestFormResourceModel from '../../generated/types/model/resource/RequestFormResourceModel';

export default class RequestFormResourceViewModel extends RequestFormResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
